import * as React from 'react';

import { useCtrlKey } from '../../../hooks/useCtrlKey';
import AsyncCommandMenu from './AsyncCommandMenu';

const CommandMenuProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const [open, setOpen] = useCtrlKey('k');

    return (
        <>
            <AsyncCommandMenu open={open} onOpenChange={setOpen} />
            {children}
        </>
    );
};

export default CommandMenuProvider;
